// extracted by mini-css-extract-plugin
module.exports = {"logo":"style_logo__1Y62a","logo__name":"style_logo__name__3aENW","header":"style_header__2vxhO"};